/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Booking } from '../../service/booking';
import * as Yup from 'yup';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { toast } from 'react-toastify';

const borderColor =
  'border border-disableGray !p-1.5 !pr-8 text-xs md:text-md lg:!py-4 md:!pl-3 md:!pr-10 rounded-1 shadow-md w-full cursor-pointer   !h-full';

const selectCountries = [
  { label: 'Which Country Do you need Service ?', value: '' },
];

const selectCities = [{ label: 'What City ?', value: '' }];

const selectFacilities = [
  { label: 'What type of service do you want ?', value: '' },
];

const BookingForm = ({
  showTitle = true,
  blackSeparation = true,
  page = '/facilities',
  userProfileId = 160,
  roleId = 5,
}) => {
  const [countries, setCountries] = useState([...selectCountries]);
  const [cities, setCities] = useState([...selectCities]);
  const [facilities, setFacilities] = useState([...selectFacilities]);
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const allParams = [...params].reduce((acc, item) => {
    acc[item[0]] = item[1];
    return acc;
  }, {});

  const [loadingCities, setLoadingCities] = useState(false);
  const [loadingFacilities, setLoadingFacilities] = useState(false);

  const fetchCountries = async () => {
    try {
      const response = await Booking.getCountries();
      const countryNames = response?.data?.usr?.iso_cntry_explore || [];
      const countriesData = countryNames.map(
        ({ iso_cntry_name, iso_cntry_id }) => ({
          label: iso_cntry_name,
          value: iso_cntry_id,
        })
      );
      setCountries([...selectCountries, ...countriesData]);
    } catch (err) {
      toast.error(
        `Error fetching countries: ${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    }
  };

  const getCitiesOfCountry = async (countryId) => {
    setLoadingCities(true);
    try {
      const response = await Booking.getCities({
        isSelectedCountryId: countryId,
        sys_user_id: userProfileId,
        role_id: roleId,
      });
      const cityNames = response?.data?.usr?.iso_city || [];
      const citiesData = cityNames.map(({ iso_city_name, iso_city_id }) => ({
        label: iso_city_name,
        value: iso_city_id,
      }));
      setCities([...selectCities, ...citiesData]);
    } catch (err) {
      toast.error(
        `Error fetching cities: ${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    } finally {
      setLoadingCities(false);
    }
  };

  const getServices = async (cityId) => {
    setLoadingFacilities(true);
    try {
      const response = await Booking.getCitiesFacilitties({
        isSelectedCityId: cityId,
        role_id: roleId,
        sys_user_id: userProfileId,
      });
      const facilitiesData = response?.data?.usr?.FacSvcTyp.map(
        ({ svc_typ_desc, svc_typ_id }) => ({
          label: svc_typ_desc,
          value: svc_typ_id,
        })
      );
      setFacilities([...selectFacilities, ...facilitiesData]);
    } catch (err) {
      toast.error(
        `Error fetching services: ${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    } finally {
      setLoadingFacilities(false);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const formik = useFormik({
    initialValues: {
      country: allParams.iso_cntry_id || '',
      city: allParams.iso_city_id || '',
      service: allParams.svc_type_id || '',
      provider: allParams.svc_provider_name || '',
    },
    validationSchema: Yup.object({
      country: Yup.string(),
      city: Yup.string(),
      service: Yup.string(),
      provider: Yup.string(),
    }),
    onSubmit: async (values) => {
      const queryParams = {};

      if (values?.provider) {
        queryParams.svc_provider_name = values.provider;
      }
      if (values?.country) {
        queryParams.iso_cntry_id = values.country;
      }
      if (values?.city) {
        queryParams.iso_city_id = values.city;
      }
      if (values?.service) {
        queryParams.svc_type_id = values?.service;
      }

      const queryString = new URLSearchParams(queryParams).toString();
      try {
        const response = await Booking.getFacilities({ ...queryParams });
        if (response?.status === 200) {
          // In case the page is to be retained

          // const pathname = ["/map", "/facilities"].includes(location.pathname)  ? location.pathname : "/facilities"; history.push(`${pathname}?${queryString}`);
          history.push(`${page}?${queryString}`);
        }
      } catch (err) {
        toast.error(
          `Error submitting form: ${
            err.response?.data?.usr?.message ||
            err.response?.data?.message ||
            err.response?.message ||
            err.message
          }`
        );
      }
    },
  });

  useEffect(() => {
    if (formik.values.country) {
      getCitiesOfCountry(formik.values.country);
      setFacilities(selectFacilities);
    }
  }, [formik.values.country]);

  useEffect(() => {
    if (formik.values.city) {
      getServices(formik.values.city);
    }
  }, [formik.values.city]);

  const Select = ({ name, options, disabled, loading }) => (
    <div className="!relative !h-full">
      <select
        id={name}
        name={name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[name]}
        className={classNames(borderColor, {
          'bg-disableGray !cursor-not-allowed custom-select ': disabled,
        })}
        disabled={disabled}
      >
        {loading ? (
          <option>Loading...</option>
        ) : (
          options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))
        )}
      </select>

      <div className="absolute top-0 right-3  flex justify-center items-center h-full">
        <img
          src="/health/images/downArrow.svg"
          className="h-3 w-3   "
          alt="Arrow"
        />
      </div>
    </div>
  );

  return (
    <div className="flex lg:justify-center lg:items-center ">
      <div className="rounded-lg w-full">
        <form onSubmit={formik.handleSubmit}>
          <div className="text-2xl font-semibold">
            {showTitle && 'Explore Our Services'}
          </div>
          <div className="flex flex-col md:flex-row justify-between px-0 lg:px-2.5 gap-x-0 gap-y-2 md:gap-2 md:gap-y-7">
            <div className="w-full md:w-7/12 gap-2 md:gap-4 flex">
              <div className="w-full">
                <Select
                  value={formik.values.country}
                  handleBlur={formik.handleBlur}
                  name="country"
                  options={countries}
                  disabled={false}
                  loading={false}
                  handleChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldValue('city', '');
                  }}
                  className={borderColor}
                />
              </div>
              <div className="w-full">
                <Select
                  value={formik.values.city}
                  handleBlur={formik.handleBlur}
                  name="city"
                  options={cities}
                  disabled={!formik.values.country}
                  loading={loadingCities}
                  className={classNames(borderColor, {
                    'bg-disableGray !cursor-not-allowed custom-select !pr-20':
                      !formik.values.country,
                  })}
                  handleChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldValue('service', '');
                  }}
                />
              </div>
              <div className="w-full">
                <Select
                  value={formik.values.service}
                  handleBlur={formik.handleBlur}
                  name="service"
                  options={facilities}
                  disabled={!formik.values.city}
                  loading={loadingFacilities}
                  handleChange={(e) => {
                    formik.handleChange(e);
                  }}
                  className={classNames(borderColor, {
                    'bg-disableGray !cursor-not-allowed custom-select !pr-20':
                      !formik.values.city,
                  })}
                />
              </div>
            </div>
            <div
              className={classNames(
                'w-full md:w-1/12 flex items-center justify-center font-semibold text-xl',
                { 'text-white': !blackSeparation },
                { 'text-black': blackSeparation }
              )}
            >
              OR
            </div>
            <div className="w-full md:w-4/12 flex gap-2 md:gap-4">
              <div className="w-full">
                <input
                  id="provider"
                  name="provider"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.provider}
                  className={borderColor}
                  placeholder="Search Provider ..."
                />
              </div>
              <div className="w-full md:w-full flex justify-end lg:justify-start">
                <button
                  type="submit"
                  className="uppercase text-xs cursor-pointer font-medium text-white !p-1.5 lg:!p-3 w-full bg-darkBlue hover:bg-primaryBlue rounded-1 tracking-0.5px"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BookingForm;
